import { render, staticRenderFns } from "./ethnicity.vue?vue&type=template&id=001ce9b0&"
import script from "./ethnicity.vue?vue&type=script&lang=js&"
export * from "./ethnicity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports